module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"form light-form overflow__no\">\n    <div name=\"form-body\" class=\"wh100 light-form-body\" />\n\n    ")
    ;  if (widget.showCloseBtn) { 
    ; __append("\n    <span class=\"i-close\" on-click=\"onCloseClick\"></span>\n    <span class=\"i-back\" on-click=\"onCloseClick\"></span>\n    ")
    ;  } 
    ; __append("\n</div>")
  }
  return __output.join("");

}